import { modalController } from "@ionic/vue";

export default (isSetExpirationTime: boolean = true) => {
  const appStore = useAppStore(); // 用户store
  const channelStore = useChannelStore(); // 渠道store
  isSetExpirationTime && channelStore.setCompulsoryInstallTime(channelStore.promotionInfo?.popupInterval);
  appStore.modalVisible = false;
  modalController.dismiss();
}
